import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
  Button
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import CardReference from '../../components/CardReference';
import Item from '../../components/Item';
import ListTag from '../../components/ListTag';
import { get } from 'lodash';
import { API_HOST } from '../../../src/consts';
import axios from 'axios';
import { toast } from 'react-toastify';
import EnviarAplicacaoModal from '../../pages/avaliacoes/EnviarAplicacaoModal';

const PreviewModal = ({
  isOpen,
  toggle,
  item,
  isAdmin,
  isOwner,
  onCopy,
  tipoId
}) => {
  const [selectedItems, setSelectedItems] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [openModal, setOpenModal] = useState(null);
  const [idCollection, setIdCollection] = useState(null);

  const toggleModal = (modal) => {
    setOpenModal((prevModal) => (prevModal === modal ? null : modal));
  };

  const toggleEnviarAvaliacaoModal = (idCollection) => {
    toggleModal('enviarAplicacao');
    setIdCollection(idCollection);
  };

  const handleExportToExams = () => {
    axios
      .get(`${API_HOST}/avaliacoes/avaliacao/${item.id}/exame`)
      .then((response) => {
        toast.success('Aplicação enviada com sucesso.');
        toggleEnviarAvaliacaoModal(response.data.collection.id);
      })
      .catch(() => {
        toast.error('Ocorreu um erro ao gerar o JSON da avaliação.');
      });
  };

  const handleCopy = async (id) => {
    try {
      const response = await axios.post(
        `${API_HOST}/avaliacoes/avaliacao/${id}/copy`
      );

      const newActivityId = response.data.id;
      toast.success('Cópia efetuada com sucesso.');
      onCopy();
      toggle();
      window.location.href = `${window.location.protocol}//${window.location.host}/instrumentos-cognitivos/${newActivityId}/dados/tipo/3`;
    } catch (error) {
      const status = get(error, 'response.status');
      if (status === 404) {
        const errorMessage = get(error, 'response.data.detail');
        toast.error(errorMessage);
      } else {
        toast.error('Aconteceu um erro. A cópia não foi efetuada.');
      }
    }
  };

  const handleClickEdit = () => {
    if (isAdmin || isOwner) {
      window.location.href = `${window.location.protocol}//${window.location.host}/instrumentos-cognitivos/${item.id}/dados/tipo/${tipoId}`;
    } else {
      handleCopy(item.id);
    }
  };

  const fetchSelectedItems = async (atividadeId) => {
    try {
      setIsLoading(true);
      const response = await axios.get(
        `${API_HOST}/avaliacoes/avaliacao_item?avaliacao=${atividadeId}`,
        {}
      );
      const formattedItems = response.data.map((responseItem) => {
        return {
          ...responseItem.item,
          valor: formatValue(responseItem.valor),
          itemId: responseItem.id
        };
      });
      setSelectedItems(formattedItems);
    } catch (error) {
      console.error('Error fetching selected items:', error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (item && item.id) {
      fetchSelectedItems(item.id);
    }
  }, [item]);

  const formatValue = (stringValue) => {
    if (!stringValue) {
      return null;
    }
    const numeroFloat = parseFloat(stringValue.replace(',', '.')).toFixed(2);
    return numeroFloat;
  };

  const styles = (theme) => ({
    root: {
      margin: 0,
      padding: theme.spacing(2),
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    closeButton: {
      right: theme.spacing(1),
      color: theme.palette.grey[500]
    }
  });

  const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
      <MuiDialogTitle disableTypography className={classes.root} {...other}>
        <Typography
          variant="h6"
          style={{
            color: '#333',
            fontFamily: 'Public Sans',
            fontSize: '20px',
            fontStyle: 'normal',
            fontWeight: 600,
            lineHeight: 'normal',
            marginLeft: '5px'
          }}
        >
          {children}
        </Typography>

        <Button
          onClick={handleClickEdit}
          style={{
            width: '71px',
            height: '31px',
            borderRadius: '24px',
            backgroundColor: '#CBE4FF',
            color: '#0047B6',
            textAlign: 'center',
            fontFamily: 'Public Sans',
            fontSize: '16px',
            fontStyle: 'normal',
            fontWeight: 700,
            lineHeight: '24px'
          }}
        >
          Editar
        </Button>
      </MuiDialogTitle>
    );
  });

  return (
    <>
      <Dialog
        open={isOpen}
        maxWidth="lg"
        fullWidth={true}
        aria-labelledby="responsive-dialog-title"
        onClose={() => toggle(null)}
      >
        <DialogTitle>Pré-visualização</DialogTitle>

        <DialogContent className="bg-white pb-0" dividers>
          <EnviarAplicacaoModal
            isOpen={openModal === 'enviarAplicacao'}
            toggle={() => toggleEnviarAvaliacaoModal(null)}
            idCollection={idCollection}
          />

          {isLoading ? (
            <p>Loading...</p>
          ) : (
            selectedItems.map((selectedItem) => (
              <CardReference
                key={selectedItem.itemId}
                descricao={
                  <div className="row">
                    <div className="col-md-9 list-data-title">
                      <h3>
                        Objeto de aprendizagem {selectedItem.id} - Código
                        externo {selectedItem.external_id}
                      </h3>
                    </div>
                    <div className="col-md-3 mb-3">
                      <ListTag
                        label={get(selectedItem, 'status.descricao')}
                        color={get(selectedItem, 'status.cor')}
                      />
                    </div>
                    <div className="col-md-12">
                      <Item item={selectedItem} />
                    </div>
                  </div>
                }
                disabledCheckBox={true}
                borderRight={false}
              />
            ))
          )}
        </DialogContent>

        <DialogActions style={{ padding: '12px 30px 12px 0px' }}>
          <div className="col-4 text-right">
            <Button className="btn btn-white" onClick={toggle}>
              Fechar
            </Button>

            {/* <Button
              // className="btn btn-white"
              onClick={() => {
                handleExportToExams();
              }}
              style={{
                marginLeft: '10px',
                backgroundColor: '#0047B6',
                borderRadius: '24px',
                padding: '8px 20px',
                color: '#FFFFFF'
              }}
            >
              Aplicar
            </Button> */}
          </div>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default PreviewModal;
